import { render, staticRenderFns } from "./AttachmentFieldContainer.vue?vue&type=template&id=a54d7fc8&"
import script from "./AttachmentFieldContainer.vue?vue&type=script&lang=js&"
export * from "./AttachmentFieldContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports